module.exports = __webpack_public_path__ + "static/img/Taylor_Adams_desktop.4c4dab3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taylor_Adams_desktop.jpg
// module id = 9ekq
// module chunks = 0